import WebFont from 'webfontloader';
import { webFontConfig } from './app';

// application entry point
WebFont.load(webFontConfig);
